import React from "react";
import "./index.css"

interface TopItemProps {
  id: any;
  name: string;
  owner: string;
  earnings: number;
  image: string;
}

interface TopItemListProps {
  title: string;
  items: TopItemProps[];
}

const TopItemList: React.FC<TopItemListProps> = ({ title, items }) => {
  return (
    <div className="top-item-list">
      <h3>{title}</h3>
      <ul>
        {items.map((item, index) => (
          <li key={item.id} className="top-item">
            <span className="top-item-rank">{index + 1}</span>
            <img src={item.image} alt={item.name} className="top-item-image" />
            <div className="top-item-info">
              <span className="top-item-name">{item.name}-</span>
              <span className="top-item-owner">{item.owner}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopItemList;
